import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import HousecallAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/HousecallAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';

const HousecallBookingStrategy = {
  previewInfo: {
    name: 'Housecall app',
    iconSvg: <HousecallAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Housecall app',
    category: 'Online booking + app booking',
    details: (
      <div>
        <div>The easiest way to delight your customers.</div>
        <Spacer20 />
        <div>
          The Housecall consumer app is the official app from Housecall Pro. It is available on the web, iOS and
          Android. The app allows your customers to book your services, chat with you during the job, view line items
          and service progression, sign-off on your labor and materials, and pay conveniently from an app.
        </div>
        <Spacer20 />
        <div>Your customers will be your biggest fans. Coming back for repeat work. Referring their friends.</div>
      </div>
    ),
    iconSvg: <HousecallAppIcon size="xlarge" />,
  },
  media: {
    youtubeId: 'GgfxKIrzxho',
  },
  sellingPoints: {
    headline: '',
    description: '',
    orderedPoints: [],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Housecall Pro Add-on Price',
    description: (
      <Typography align="left" variant="body2" color="textSecondary">
        Customers sourced and booked through the Housecall app are subject to a 10% referral fee on Labor & Services,
        excluding Materials. The referral fee is charged only if you get a job and after payment is completed.
      </Typography>
    ),
  },
  supportContacts: [],
};

export default HousecallBookingStrategy;
